const tokenSession = token => {
  return {
    type: "token",
    token
  };
};

export default tokenSession;
